import z, { Infer } from "myzod";

export const viewportSchema = z.object({
  width: z.number({ min: 0 }),
  height: z.number({ min: 0 })
});
export type Viewport = Infer<typeof viewportSchema>;
